export type EditionStr =
  | "launch"
  | "limited"
  | "standard"
  | "acceleration"
  | "enterprise";

export interface EditionFeatures {
  name: EditionStr;
  displayName: string;
  allowSorting: boolean;
  // other & business
  allowAllInfoTypes: boolean;
  timeFrameFull: boolean;
  hasResultLimit: boolean;
  resultsLimit: number;
  contentLabelCustomization: boolean;
  contentLabelsApp: boolean;
  riskTypeCustomization: boolean;
  export: boolean;
  filters: boolean;
  topics: boolean;
  extraDimens: boolean;
  mip: boolean;
  mcas: boolean;
}

export const LaunchEdition: EditionFeatures = {
  name: "launch",
  displayName: "Launch",
  allowSorting: false,
  timeFrameFull: false,
  allowAllInfoTypes: true,
  hasResultLimit: false,
  resultsLimit: 20,
  export: false,
  filters: false,
  topics: false,
  contentLabelCustomization: false,
  contentLabelsApp: false,
  riskTypeCustomization: false,
  extraDimens: false,
  mip: false,
  mcas: false,
};

export const LimitedEdition: EditionFeatures = {
  name: "limited",
  displayName: "Launch",
  allowSorting: false,
  timeFrameFull: false,
  allowAllInfoTypes: true,
  hasResultLimit: false,
  resultsLimit: 100,
  export: false,
  filters: false,
  topics: false,
  contentLabelCustomization: false,
  contentLabelsApp: false,
  riskTypeCustomization: false,
  extraDimens: false,
  mip: false,
  mcas: false,
};

export const StandardEdition: EditionFeatures = {
  name: "standard",
  displayName: "Standard",
  allowSorting: true,
  timeFrameFull: true,
  allowAllInfoTypes: true,
  hasResultLimit: false,
  resultsLimit: Infinity,
  export: true,
  filters: true,
  topics: true,
  contentLabelCustomization: false,
  contentLabelsApp: true,
  riskTypeCustomization: true,
  extraDimens: true,
  mip: true,
  mcas: true,
};

export const AcceleratedEdition: EditionFeatures = {
  name: "acceleration",
  displayName: "Acceleration",
  allowSorting: true,
  timeFrameFull: true,
  allowAllInfoTypes: true,
  hasResultLimit: false,
  resultsLimit: Infinity,
  export: true,
  filters: true,
  topics: false,
  contentLabelCustomization: false,
  contentLabelsApp: true,
  riskTypeCustomization: true,
  extraDimens: false,
  mip: true,
  mcas: true,
};

export const EnterpriseEdition: EditionFeatures = {
  name: "enterprise",
  displayName: "Enterprise",
  allowSorting: true,
  timeFrameFull: true,
  allowAllInfoTypes: true,
  hasResultLimit: false,
  resultsLimit: Infinity,
  export: true,
  filters: true,
  topics: true,
  contentLabelCustomization: true,
  contentLabelsApp: true,
  riskTypeCustomization: true,
  extraDimens: true,
  mip: true,
  mcas: true,
};

export function toEdition(editionStr: EditionStr) {
  switch (editionStr) {
    case "limited":
      return LimitedEdition;
    case "standard":
      return StandardEdition;
    case "acceleration":
      return AcceleratedEdition;
    case "enterprise":
      return EnterpriseEdition;
    case "launch":
    default:
      return LaunchEdition;
  }
}

export function editionToNumber(editionStr: string) {
  switch (editionStr) {
    case "limited":
      return 1;
    case "standard":
      return 2;
    case "acceleration":
      return 3;
    case "enterprise":
      return 4;
    case "launch":
    default:
      return 0;
  }
}

export const is_edition = (str: string) => {
  return [
    "launch",
    "limited",
    "standard",
    "acceleration",
    "enterprise",
  ].includes(str);
};

export const isEditionHighEnough = (p: {
  userEdition: EditionStr;
  minEdition: EditionStr;
}) => {
  const { minEdition, userEdition } = p;
  const editions = [
    "launch",
    "limited",
    "standard",
    "acceleration",
    "enterprise",
  ];
  return (
    editions.indexOf(userEdition.toLowerCase()) >=
    editions.indexOf(minEdition.toLowerCase())
  );
};
